exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".questions[data-v-142a542a] {\n  padding: 12px 56px 0;\n}\n[data-v-142a542a] .questions__main .material-icons {\n  display: none;\n}\n[data-v-142a542a] .questions__main .material-icons:first-child {\n  display: inline-block;\n}\n.buttons[data-v-142a542a] {\n  padding: 0 24px 0;\n}\n.fab-desc[data-v-142a542a] {\n  width: 56px;\n  margin: 8px 0;\n  text-align: center;\n  font-size: 12px;\n  line-height: 16px;\n  color: rgba(0, 0, 0, 0.6);\n}\n[data-v-142a542a] .material-icons.mdc-fab__icon {\n  font-family: 'Roboto';\n  font-weight: 500;\n}\n", ""]);

// exports
